export default "__VITE_ASSET__Cx27lo3n__"